import { apiSlice as api } from '../../../../apiSlice';
export const addTagTypes = ['Buildings'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      buildingsGetCollectionAsyncByqueryOptions: build.query<
        BuildingsGetCollectionAsyncByqueryOptionsApiResponse,
        BuildingsGetCollectionAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Building`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            'Account.AccountId': queryArg['Account.AccountId'],
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['Buildings'],
      }),
      buildingsCreateAsyncBybuildingDto: build.mutation<
        BuildingsCreateAsyncBybuildingDtoApiResponse,
        BuildingsCreateAsyncBybuildingDtoApiArg
      >({
        query: (queryArg) => ({
          url: `/Building`,
          method: 'POST',
          body: queryArg.createBuildingDto,
        }),
        invalidatesTags: ['Buildings'],
      }),
      buildingsGetAsyncBybuildingId: build.query<
        BuildingsGetAsyncBybuildingIdApiResponse,
        BuildingsGetAsyncBybuildingIdApiArg
      >({
        query: (queryArg) => ({ url: `/Building/${queryArg.buildingId}` }),
        providesTags: ['Buildings'],
      }),
      buildingsUpdateAsyncBybuildingIdbuildingDto: build.mutation<
        BuildingsUpdateAsyncBybuildingIdbuildingDtoApiResponse,
        BuildingsUpdateAsyncBybuildingIdbuildingDtoApiArg
      >({
        query: (queryArg) => ({
          url: `/Building/${queryArg.buildingId}`,
          method: 'PUT',
          body: queryArg.editBuildingDto,
        }),
        invalidatesTags: ['Buildings'],
      }),
      buildingsPutStateAsyncByidstate: build.mutation<
        BuildingsPutStateAsyncByidstateApiResponse,
        BuildingsPutStateAsyncByidstateApiArg
      >({
        query: (queryArg) => ({
          url: `/Building/${queryArg.id}/State`,
          method: 'PUT',
          body: queryArg.body,
        }),
        invalidatesTags: ['Buildings'],
      }),
      buildingsGetBillingMetersForBuildingAsyncBybuildingId: build.query<
        BuildingsGetBillingMetersForBuildingAsyncBybuildingIdApiResponse,
        BuildingsGetBillingMetersForBuildingAsyncBybuildingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Building/${queryArg.buildingId}/BillingMeters`,
        }),
        providesTags: ['Buildings'],
      }),
      buildingsCreateBillingMeterAsyncBybuildingIdbillingMeterDto:
        build.mutation<
          BuildingsCreateBillingMeterAsyncBybuildingIdbillingMeterDtoApiResponse,
          BuildingsCreateBillingMeterAsyncBybuildingIdbillingMeterDtoApiArg
        >({
          query: (queryArg) => ({
            url: `/Building/${queryArg.buildingId}/BillingMeters`,
            method: 'POST',
            body: queryArg.createBillingMeterDto,
          }),
          invalidatesTags: ['Buildings'],
        }),
      buildingsGetBillingMeterAsyncBybuildingIdbillingMeterId: build.query<
        BuildingsGetBillingMeterAsyncBybuildingIdbillingMeterIdApiResponse,
        BuildingsGetBillingMeterAsyncBybuildingIdbillingMeterIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Building/${queryArg.buildingId}/BillingMeters/${queryArg.billingMeterId}`,
        }),
        providesTags: ['Buildings'],
      }),
      buildingsDeleteBuildingBillingMeterAsyncBybuildingIdbillingMeterId:
        build.mutation<
          BuildingsDeleteBuildingBillingMeterAsyncBybuildingIdbillingMeterIdApiResponse,
          BuildingsDeleteBuildingBillingMeterAsyncBybuildingIdbillingMeterIdApiArg
        >({
          query: (queryArg) => ({
            url: `/Building/${queryArg.buildingId}/BillingMeters/${queryArg.billingMeterId}`,
            method: 'DELETE',
          }),
          invalidatesTags: ['Buildings'],
        }),
      buildingsAttachJobSubscriptionToBuildingAsyncBybuildingIdjobSubscriptionId:
        build.mutation<
          BuildingsAttachJobSubscriptionToBuildingAsyncBybuildingIdjobSubscriptionIdApiResponse,
          BuildingsAttachJobSubscriptionToBuildingAsyncBybuildingIdjobSubscriptionIdApiArg
        >({
          query: (queryArg) => ({
            url: `/Building/${queryArg.buildingId}/JobSubscriptions/${queryArg.jobSubscriptionId}`,
            method: 'POST',
          }),
          invalidatesTags: ['Buildings'],
        }),
      buildingsRemoveJobSubscriptionFromBuildingAsyncBybuildingIdjobSubscriptionId:
        build.mutation<
          BuildingsRemoveJobSubscriptionFromBuildingAsyncBybuildingIdjobSubscriptionIdApiResponse,
          BuildingsRemoveJobSubscriptionFromBuildingAsyncBybuildingIdjobSubscriptionIdApiArg
        >({
          query: (queryArg) => ({
            url: `/Building/${queryArg.buildingId}/JobSubscriptions/${queryArg.jobSubscriptionId}`,
            method: 'DELETE',
          }),
          invalidatesTags: ['Buildings'],
        }),
      buildingsGetTokensAsyncBybuildingId: build.query<
        BuildingsGetTokensAsyncBybuildingIdApiResponse,
        BuildingsGetTokensAsyncBybuildingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Building/${queryArg.buildingId}/Tokens`,
        }),
        providesTags: ['Buildings'],
      }),
      buildingsCreateTokenAsyncBybuildingIdcreateTokenModel: build.mutation<
        BuildingsCreateTokenAsyncBybuildingIdcreateTokenModelApiResponse,
        BuildingsCreateTokenAsyncBybuildingIdcreateTokenModelApiArg
      >({
        query: (queryArg) => ({
          url: `/Building/${queryArg.buildingId}/Tokens`,
          method: 'POST',
          body: queryArg.createTokenModel,
        }),
        invalidatesTags: ['Buildings'],
      }),
      buildingsGetTokenAsyncBybuildingIdtoken: build.query<
        BuildingsGetTokenAsyncBybuildingIdtokenApiResponse,
        BuildingsGetTokenAsyncBybuildingIdtokenApiArg
      >({
        query: (queryArg) => ({
          url: `/Building/${queryArg.buildingId}/Tokens/${queryArg.token}`,
        }),
        providesTags: ['Buildings'],
      }),
      buildingsInvalidateTokenAsyncBybuildingIdtoken: build.mutation<
        BuildingsInvalidateTokenAsyncBybuildingIdtokenApiResponse,
        BuildingsInvalidateTokenAsyncBybuildingIdtokenApiArg
      >({
        query: (queryArg) => ({
          url: `/Building/${queryArg.buildingId}/Tokens/${queryArg.token}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Buildings'],
      }),
      buildingsIsBuildingActivelyControlledAsyncBybuildingId: build.query<
        BuildingsIsBuildingActivelyControlledAsyncBybuildingIdApiResponse,
        BuildingsIsBuildingActivelyControlledAsyncBybuildingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Building/${queryArg.buildingId}/IsControlActive`,
        }),
        providesTags: ['Buildings'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcOpenApi };
export type BuildingsGetCollectionAsyncByqueryOptionsApiResponse =
  /** status 200 Buildings entities response */ ReadBuildingDto[];
export type BuildingsGetCollectionAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>BuildingId</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>BuildingId</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Account.AccountId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  'Account.AccountId'?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type BuildingsCreateAsyncBybuildingDtoApiResponse =
  /** status 201 Created */ object;
export type BuildingsCreateAsyncBybuildingDtoApiArg = {
  /** The new Building */
  createBuildingDto: CreateBuildingDto;
};
export type BuildingsGetAsyncBybuildingIdApiResponse =
  /** status 200 Building entity response */ ReadBuildingDto;
export type BuildingsGetAsyncBybuildingIdApiArg = {
  /** BuildingId */
  buildingId: number;
};
export type BuildingsUpdateAsyncBybuildingIdbuildingDtoApiResponse =
  /** status 200 Ok */ object;
export type BuildingsUpdateAsyncBybuildingIdbuildingDtoApiArg = {
  /** BuildingId */
  buildingId: number;
  /** The updated Building */
  editBuildingDto: EditBuildingDto;
};
export type BuildingsPutStateAsyncByidstateApiResponse =
  /** status 204 No content */ object;
export type BuildingsPutStateAsyncByidstateApiArg = {
  /** The id of the Building */
  id: number;
  /** The new state */
  body: object;
};
export type BuildingsGetBillingMetersForBuildingAsyncBybuildingIdApiResponse =
  /** status 200 BillingMeter entities response */ ReadBillingMeterDto[];
export type BuildingsGetBillingMetersForBuildingAsyncBybuildingIdApiArg = {
  /** BuildingId */
  buildingId: number;
};
export type BuildingsCreateBillingMeterAsyncBybuildingIdbillingMeterDtoApiResponse =
  /** status 201 Created */ object;
export type BuildingsCreateBillingMeterAsyncBybuildingIdbillingMeterDtoApiArg =
  {
    /** BuildingId */
    buildingId: number;
    /** The new BillingMeter */
    createBillingMeterDto: CreateBillingMeterDto;
  };
export type BuildingsGetBillingMeterAsyncBybuildingIdbillingMeterIdApiResponse =
  /** status 200 BillingMeter entity response */ ReadBillingMeterDto;
export type BuildingsGetBillingMeterAsyncBybuildingIdbillingMeterIdApiArg = {
  /** BuildingId */
  buildingId: number;
  /** BillingMeterId */
  billingMeterId: number;
};
export type BuildingsDeleteBuildingBillingMeterAsyncBybuildingIdbillingMeterIdApiResponse =
  /** status 200 Ok */ object;
export type BuildingsDeleteBuildingBillingMeterAsyncBybuildingIdbillingMeterIdApiArg =
  {
    /** BuildingId */
    buildingId: number;
    /** BillingMeterId */
    billingMeterId: number;
  };
export type BuildingsAttachJobSubscriptionToBuildingAsyncBybuildingIdjobSubscriptionIdApiResponse =
  /** status 200 Ok */ object;
export type BuildingsAttachJobSubscriptionToBuildingAsyncBybuildingIdjobSubscriptionIdApiArg =
  {
    /** BuildingId */
    buildingId: number;
    /** JobSubscriptionId */
    jobSubscriptionId: number;
  };
export type BuildingsRemoveJobSubscriptionFromBuildingAsyncBybuildingIdjobSubscriptionIdApiResponse =
  /** status 200 OK */ object;
export type BuildingsRemoveJobSubscriptionFromBuildingAsyncBybuildingIdjobSubscriptionIdApiArg =
  {
    /** BuildingId */
    buildingId: number;
    /** JobSubscriptionId */
    jobSubscriptionId: number;
  };
export type BuildingsGetTokensAsyncBybuildingIdApiResponse =
  /** status 200 OK */ object;
export type BuildingsGetTokensAsyncBybuildingIdApiArg = {
  /** BuildingId */
  buildingId: number;
};
export type BuildingsCreateTokenAsyncBybuildingIdcreateTokenModelApiResponse =
  /** status 201 Created */ object;
export type BuildingsCreateTokenAsyncBybuildingIdcreateTokenModelApiArg = {
  /** BuildingId */
  buildingId: number;
  createTokenModel: CreateTokenModel;
};
export type BuildingsGetTokenAsyncBybuildingIdtokenApiResponse =
  /** status 200 OK */ object;
export type BuildingsGetTokenAsyncBybuildingIdtokenApiArg = {
  /** BuildingId */
  buildingId: number;
  /** Token */
  token: string;
};
export type BuildingsInvalidateTokenAsyncBybuildingIdtokenApiResponse =
  /** status 200 OK */ object;
export type BuildingsInvalidateTokenAsyncBybuildingIdtokenApiArg = {
  /** BuildingId */
  buildingId: number;
  /** Token */
  token: string;
};
export type BuildingsIsBuildingActivelyControlledAsyncBybuildingIdApiResponse =
  /** status 200 OK */ object;
export type BuildingsIsBuildingActivelyControlledAsyncBybuildingIdApiArg = {
  /** BuildingId */
  buildingId: number;
};
export type LocationDto = {
  Address?: string;
  Latitude?: number;
  Longitude?: number;
};
export type ReadBillingMeterDto = {
  BillingMeterId: number;
  BuildingId: number;
  BillingMeterType:
    | 'HeatMeter'
    | 'GasMeter'
    | 'WaterMeter'
    | 'ElectricityMeter';
  UnitId: number;
  UnitTypeInputId?: number;
  DataType?: string;
};
export type ReadBuildingDto = {
  BuildingId: number;
  Name?: string;
  Location?: LocationDto;
  AccountId: number;
  BillingMeters?: ReadBillingMeterDto[];
  JobSubscriptions?: number[];
  BaselineDayInterval?: number;
  BaselineDayOffset: string;
  AllowSaturdayBaselineDay: boolean;
  State?: object;
  UserInput?: {
    [key: string]: object;
  };
};
export type ErrorResult = {
  Code: string;
  Message: string;
};
export type BadRequestError = {
  Code: string;
  Message: string;
};
export type PropertyValueError = {
  Property: string;
  Code: string;
  Message: string;
};
export type ArrayProperty = {
  Property?: ArrayProperty;
  Name: string;
  Index?: number;
};
export type ArrayPropertyValueError = {
  Property: ArrayProperty;
  Code: string;
  Message: string;
};
export type ErrorDetailsResult2 = ErrorResult & {
  BadRequestErrors?: BadRequestError[];
  PropertyValueErrors?: PropertyValueError[];
  ArrayPropertyValueErrors?: ArrayPropertyValueError[];
};
export type ErrorDetailsResult = ErrorDetailsResult2;
export type ErrorResult2 = ErrorResult;
export type ErrorResult3 = ErrorResult;
export type CreateBuildingDto = {
  Name: string;
  Location?: LocationDto;
  UserInput?: {
    [key: string]: object;
  };
  AccountId: number;
  BaselineDayInterval?: number;
  BaselineDayOffset?: string;
  AllowSaturdayBaselineDay: boolean;
};
export type ErrorResult4 = ErrorResult;
export type EditBuildingDto = {
  Name?: string;
  Location?: LocationDto;
  BaselineDayInterval?: number;
  BaselineDayOffset?: string;
  AllowSaturdayBaselineDay: boolean;
  UserInput?: {
    [key: string]: object;
  };
};
export type CreateBillingMeterDto = {
  BillingMeterType:
    | 'HeatMeter'
    | 'GasMeter'
    | 'WaterMeter'
    | 'ElectricityMeter';
  UnitId: number;
  UnitTypeInputId: number;
  DataType: string;
};
export type CreateTokenModel = {
  Name?: string;
  Description?: string;
};
export const {
  useBuildingsGetCollectionAsyncByqueryOptionsQuery,
  useLazyBuildingsGetCollectionAsyncByqueryOptionsQuery,
  useBuildingsCreateAsyncBybuildingDtoMutation,
  useBuildingsGetAsyncBybuildingIdQuery,
  useLazyBuildingsGetAsyncBybuildingIdQuery,
  useBuildingsUpdateAsyncBybuildingIdbuildingDtoMutation,
  useBuildingsPutStateAsyncByidstateMutation,
  useBuildingsGetBillingMetersForBuildingAsyncBybuildingIdQuery,
  useLazyBuildingsGetBillingMetersForBuildingAsyncBybuildingIdQuery,
  useBuildingsCreateBillingMeterAsyncBybuildingIdbillingMeterDtoMutation,
  useBuildingsGetBillingMeterAsyncBybuildingIdbillingMeterIdQuery,
  useLazyBuildingsGetBillingMeterAsyncBybuildingIdbillingMeterIdQuery,
  useBuildingsDeleteBuildingBillingMeterAsyncBybuildingIdbillingMeterIdMutation,
  useBuildingsAttachJobSubscriptionToBuildingAsyncBybuildingIdjobSubscriptionIdMutation,
  useBuildingsRemoveJobSubscriptionFromBuildingAsyncBybuildingIdjobSubscriptionIdMutation,
  useBuildingsGetTokensAsyncBybuildingIdQuery,
  useLazyBuildingsGetTokensAsyncBybuildingIdQuery,
  useBuildingsCreateTokenAsyncBybuildingIdcreateTokenModelMutation,
  useBuildingsGetTokenAsyncBybuildingIdtokenQuery,
  useLazyBuildingsGetTokenAsyncBybuildingIdtokenQuery,
  useBuildingsInvalidateTokenAsyncBybuildingIdtokenMutation,
  useBuildingsIsBuildingActivelyControlledAsyncBybuildingIdQuery,
  useLazyBuildingsIsBuildingActivelyControlledAsyncBybuildingIdQuery,
} = injectedRtkApi;
